import type { App } from 'vue'
import { CHAVE_OPERACOES_CATALOGO_MOTIVO_PADRAO } from '@next/modulos/estrutura-de-ponto-da-empresa/motivo-padrao/catalogo/apresentacao/catalogo-motivo-padrao.injecao'
import type { OperacoesCatalogoMotivoPadrao } from '@next/modulos/estrutura-de-ponto-da-empresa/motivo-padrao/catalogo/catalogo-motivo-padrao.tipos'
import { criarCasoDeUsoListarOpcoesMotivoPadrao } from '@next/modulos/estrutura-de-ponto-da-empresa/motivo-padrao/catalogo/listar-opcoes/listar-opcoes-motivo-padrao'
import { ListarOpcoesMotivoPadraoRepositorioHttp } from '@next/modulos/estrutura-de-ponto-da-empresa/motivo-padrao/catalogo/listar-opcoes/listar-opcoes-motivo-padrao.repositorio-http'
import type { InfraestruturaAplicacao } from '../criar-infraestrutura'
export const comporCatalogoMotivoPadrao = (
  infraestrutura: InfraestruturaAplicacao,
): OperacoesCatalogoMotivoPadrao => {
  const repositorio = new ListarOpcoesMotivoPadraoRepositorioHttp(infraestrutura.httpCondominio)
  return { listarOpcoes: criarCasoDeUsoListarOpcoesMotivoPadrao(repositorio.executar) }
}
export const instalarMotivoPadrao = (app: App, infraestrutura: InfraestruturaAplicacao): void => {
  app.provide(CHAVE_OPERACOES_CATALOGO_MOTIVO_PADRAO, comporCatalogoMotivoPadrao(infraestrutura))
}
